<div #fccontainer id="fc-container">
  @if (showAlert) {
    <div>
      @if (warningsMessage.length > 0) {
        <div [ngClass]="alertType">
          <h3>Warning(s)</h3>
          <ul>
            @for (message of warningsMessage; track message) {
              <li>- {{ message }}</li>
            }
          </ul>
        </div>
      }
    </div>
  }
  <!-- WIP: Faire marcher Full calendar -->
  <full-calendar #fc
    [options]="calendarOptions"
    [events]="events"
  ></full-calendar>
</div>

@if (!selectedUser) {
  <a (click)="handleDayClick(null)" class="btn btn-raised btn-fab pull-right fixed-bottom-right"><i class="material-icons">&#xE145;</i></a>
}


<input-modal [(open)]="userModalOpened" [currentEvent]=currentEvent (closeModal)="handleCloseEvent($event)" [locked]="selectedUser!=null"></input-modal>
<justification-modal [(open)]="justificationModalOpened" [currentEvent]=currentEvent title={{justificationModalTitle}} (closeModal)="handleCloseEvent($event)"></justification-modal>
